import React from 'react';
import { FormSectionProps } from '@/lib/formTypes';
import { SignaturePad } from './SignaturePad';

export const DeclarationSection: React.FC<FormSectionProps> = ({
  data,
  errors,
  onChange,
}) => {
  const declarationText = `הנני מצהיר/ה ומתחייב/ת כי אני יכול/ה לעסוק בפעילות גופנית בהתאם למגבלות הרפואיות הידועות לי ואין המאמן/ת אחראי/ת לכל אובדן או נזק גופני העלולים להיגרם לי בתחומם. הנני מצהיר/ה כי קראתי, הבנתי ומסכים/ה לכל האמור לעיל, ושכל הפרטים נכונים.`;

  return (
    <div className="space-y-8">
      <div>
        <h3 className="text-xl font-bold text-[#1B4332] mb-6 text-right">
          חלק ג': הצהרה וחתימה
        </h3>
      </div>

      {/* Declaration Text */}
      <div className="bg-[#FFF8F0] p-6 rounded-lg border-2 border-[#E8A87C]">
        <p className="text-sm text-[#1B4332] text-right leading-relaxed">
          {declarationText}
        </p>
      </div>

      {/* Terms Checkbox */}
      <div className="flex items-start justify-end gap-3">
        <div className="flex-1">
          <label className="flex items-start gap-3 cursor-pointer">
            <input
              type="checkbox"
              checked={data.agreedToTerms || false}
              onChange={(e) => onChange('agreedToTerms', e.target.checked)}
              className="w-5 h-5 accent-[#C17A4A] mt-1 flex-shrink-0"
            />
            <span className="text-sm text-[#1B4332] text-right">
              אני מסכים/ה לתנאים הנ"ל ומאשר/ת כי כל המידע שהזנתי נכון
            </span>
          </label>
          {errors.agreedToTerms && (
            <p className="text-red-500 text-sm mt-1 text-right">{errors.agreedToTerms}</p>
          )}
        </div>
      </div>

      {/* Declaration Date */}
      <div>
        <label className="block text-right mb-2">
          <span className="text-sm font-semibold text-[#1B4332]">תאריך</span>
          <span className="text-red-500 mr-1">*</span>
        </label>
        <input
          type="date"
          value={data.declarationDate || new Date().toISOString().split('T')[0]}
          onChange={(e) => onChange('declarationDate', e.target.value)}
          className="w-full px-4 py-2 rounded-lg border-2 border-[#E8A87C] text-right focus:outline-none focus:border-[#C17A4A] transition-colors"
        />
      </div>

      {/* Signature Pad */}
      <div>
        <SignaturePad
          onSignatureChange={(sig) => onChange('signature', sig)}
          error={errors.signature}
        />
      </div>

      {/* Form Status Messages */}
      {errors.form && (
        <div className="bg-red-50 border-2 border-red-500 rounded-lg p-4">
          <p className="text-red-600 text-sm text-right">{errors.form}</p>
        </div>
      )}
    </div>
  );
};
